module.exports = __webpack_public_path__ + "assets/img/FY.c3378f08.png";